/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import { useLocation } from 'react-router';
import { Route } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../../_metronic/_helpers';
import { CardHeader } from '../../components/CardHeader';
import { MiniCard } from '../../components/MiniCard';
import { SearchInput } from '../../components/SearchInput';
import { AreasContext } from '../../contexts/AreasContext';
import compareStrings from '../../utils/compareStrings';
import AreasEdit from './AreasEdit';
import { Map } from '../../components/map/Map';
import { Button } from '../../components/Button';
import { usePermissions } from '../../contexts/PermissionsContext';
import { AddButton } from '../../components/AddButton';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';
import { CircularProgress } from '@material-ui/core';

function AreasHome({ intl, history }) {
  const location = useLocation();
  const [areas, setAreas] = useState([]);
  const [filteredAreas, setFilteredAreas] = useState([]);
  const [controller, setController] = useState(null);
  const context = useContext(AreasContext);
  const { hasPermission } = usePermissions();
  const mapRef = useRef(null);
  const { setPaths } = useBreadcrumb();

  useEffect(() => {
    setPaths([
      {
        title: intl.formatMessage({ id: 'AREAS.TITLE' }),
        pathname: '/geo-planner/areas',
      },
    ]);
  }, []);

  useEffect(() => {
    if (context.areas) {
      setAreas(context.areas);
      setFilteredAreas(context.areas);
    }
  }, [context]);

  useEffect(() => {
    if (controller && mapRef.current) {
      controller.changeMode('static');
    }
  }, [controller, mapRef]);

  function changeText(text) {
    setFilteredAreas(
      areas.filter(x => compareStrings(JSON.stringify(x), text))
    );
  }

  return !areas.length && location.pathname.endsWith('/areas') ? (
    <div className="card flex-row-fluid h-100">
      <CardHeader
        title={intl.formatMessage({ id: 'AREAS.TITLE' })}
        subtitle={intl.formatMessage({ id: 'AREAS.EMPTY.SUBTITLE' })}
        btn={
          hasPermission('areas*', 'C') && (
            <AddButton onClick={() => history.push('/geo-planner/areas/new')} />
          )
        }
      />
      {context.isLoading ? (
        <div className="w-100 h-100 d-flex flex-center">
          <CircularProgress color="secondary" />
        </div>
      ) : (
        <div className="card-body d-flex justify-content-center align-items-center flex-column">
          <div
            style={{ width: 290 }}
            className="d-flex justify-content-center align-items-center flex-column"
          >
            <SVG
              uniquifyIDs
              src={toAbsoluteUrl('/media/svg/senseworks/empty-area.svg')}
            />
            <span className="mt-3 d-block font-weight-bolder text-center">
              {' '}
              {intl.formatMessage({ id: 'AREAS.EMPTY.SUBTITLE' })}{' '}
            </span>
            {hasPermission('areas*', 'C') && (
              <Button
                classes="w-min-120px fit-height mt-3"
                type="button"
                onClick={() => history.push('/geo-planner/areas/new')}
                title={intl.formatMessage({ id: 'ADD_AREA' })}
              />
            )}
          </div>
        </div>
      )}
    </div>
  ) : (
    <div className="card flex-row-fluid h-100" id="floormap-container">
      <CardHeader
        title={intl.formatMessage({ id: 'AREAS.TITLE' })}
        subtitle={intl.formatMessage({ id: 'AREAS.SUBTITLE' })}
        btn={
          hasPermission('areas*', 'C') && (
            <AddButton onClick={() => history.push('/geo-planner/areas/new')} />
          )
        }
      />
      <div
        className="d-flex flex-sm-column flex-md-row flex-lg-row h-100"
        style={{ marginTop: -1 }}
      >
        <div
          className="col-md-2 col-lg-2 px-0 d-flex flex-column justify-content-between"
          style={{ border: 'solid 1px #AAAAAA' }}
        >
          <div
            className="px-3 py-2"
            style={{ borderBottom: 'solid 1px #AAAAAA' }}
          >
            <SearchInput onChange={changeText} />
          </div>
          <div className="d-flex flex-column h-100">
            <div className="areas-lateral">
              {filteredAreas.map(op => (
                <MiniCard
                  key={op.id + op.name}
                  state={{
                    areas,
                    filteredAreas,
                  }}
                  body={op.description}
                  title={op.name}
                  footer={`${op.locality ? op.locality + ',' : ''} ${
                    op.adminRegion
                  }${
                    op['countryISO3166-2'] ? ', ' + op['countryISO3166-2'] : ''
                  }`}
                  to={`/geo-planner/areas/${op.id}`}
                />
              ))}
            </div>
          </div>
        </div>
        <div
          className="col-md-10 col-lg-10 col-sm-12 px-0"
          style={{ border: 'solid 1px #AAAAAA' }}
        >
          <Route
            path="/geo-planner/areas/:id"
            exact
            key={location.pathname}
            render={AreasEdit}
          />
          {location.pathname.endsWith('/areas') && areas.length && (
            <Map
              mapRef={mapRef}
              setController={setController}
              geofences={areas}
              edit={false}
              mapHeight="calc(100%)"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default injectIntl(AreasHome);
